import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@material-ui/core';
import { EmojiSadOutlined as EmojiSadIcon } from 'icons/EmojiSadOutlined';

export const NotFound = () => (
  <Box sx={{ backgroundColor: 'background.default' }}>
    <Container
      maxWidth="md"
      sx={{
        px: 5,
        py: 14,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <EmojiSadIcon sx={{ color: 'text.secondary' }} />
      <Typography align="center" color="textPrimary" sx={{ my: 2 }} variant="h3">
        ¡Nada por aquí!
      </Typography>
      <Typography align="center" color="textSecondary" variant="body2">
        NO encontramos...
      </Typography>
      <Button color="primary" component={RouterLink} sx={{ mt: 2 }} to="/" variant="text">
        Vamos al inicio
      </Button>
    </Container>
  </Box>
);
